// import appLocaleData from 'react-intl/locale-data/zh';
import zhMessages from './lang/zh-CN.json';
import antdZh from 'antd/lib/locale-provider/zh_CN'; //antd语言包
// console.log(1111,appLocaleData)
let appLocale = {
  messages: {
    ...zhMessages,
  },
  antd: antdZh,
  locale: 'zh-CN',
};

export default appLocale;
